import { Link, useLocation } from 'react-router-dom'
import { ShieldExclamationIcon } from '@heroicons/react/24/outline'
import { useTranslation } from '@/i18n/useTranslation'

interface NoPermissionProps {
  moduleLabel?: string
  reason?: 'plan'
}

const NoPermission = ({ moduleLabel, reason }: NoPermissionProps) => {
  const { t } = useTranslation('dashboard')
  const location = useLocation()
  const fromLabel = (location.state as { moduleLabel?: string } | null)?.moduleLabel

  const label = fromLabel || moduleLabel || t('noPermission.defaultModule')

  return (
    <div className="min-h-[50vh] flex flex-col items-center justify-center text-center px-4">
      <div className="rounded-full bg-amber-50 p-4 mb-4">
        <ShieldExclamationIcon className="h-10 w-10 text-amber-600" aria-hidden="true" />
      </div>
      <h1 className="text-xl font-semibold text-gray-900">{t('noPermission.title')}</h1>
      <p className="text-gray-600 mt-2 max-w-md">
        {reason === 'plan'
          ? t('noPermission.planMessage', { module: label })
          : t('noPermission.message', { module: label })}
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        {reason === 'plan' ? (
          <Link to="/dashboard/settings/subscription" className="btn btn-primary">
            {t('noPermission.seePlans')}
          </Link>
        ) : null}
        <Link to="/dashboard" className={reason === 'plan' ? 'btn btn-secondary' : 'btn btn-primary'}>
          {t('noPermission.back')}
        </Link>
      </div>
    </div>
  )
}

export default NoPermission
